import React from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';

const UploadAppToggleButton = ({ onUploadClick, isOpen }) => (
  <Button
    category="action"
    onClick={() => onUploadClick(!isOpen)}
  >
    App Upload
  </Button>
);

UploadAppToggleButton.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onUploadClick: PropTypes.func.isRequired,
};

export default UploadAppToggleButton;
